import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function Transition() {
  return <section className="bg-brand-beige py-20 px-6" data-id="element-950">
      <div className="max-w-3xl mx-auto text-center" data-id="element-951">
        <FadeIn data-id="element-952">
          {/* Título principal */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-green mb-6 leading-tight" data-id="element-953">
            NO TODOS COMIENZAN CON AMAZON FBA…
            <br data-id="element-954" />
            <span className="text-brand-green/80" data-id="element-955">Y ESO ESTÁ BIEN.</span>
          </h2>

          {/* Texto secundario */}
          <p className="text-lg md:text-xl text-brand-text/70 mb-10 leading-relaxed" data-id="element-956">
            Existe una forma MÁS SIMPLE de comenzar a vender en Amazon, con
            menor inversión y mayor control desde el primer día.
          </p>

          {/* Título destacado */}
          <div className="bg-white border border-brand-green/10 rounded-2xl px-6 py-8 md:px-10 md:py-10 mb-10 shadow-sm" data-id="element-957">
            <p className="text-xs font-semibold uppercase tracking-widest text-brand-gold mb-3" data-id="element-958">
              ⚡ La alternativa práctica
            </p>
            <h3 className="text-2xl md:text-3xl font-bold text-brand-green mb-6" data-id="element-959">
              APRENDE A VENDER CON AMAZON FBM
            </h3>

            {/* Texto persuasivo */}
            <p className="text-base md:text-lg text-brand-text/80 mb-4 leading-relaxed" data-id="element-960">
              Con Amazon FBM puedes comenzar desde casa sin necesidad de enviar
              inventario a bodegas FBA.
            </p>
            <p className="text-base md:text-lg text-brand-text/80 mb-4 leading-relaxed" data-id="element-961">
              Tendrás el control de tus productos, tus envíos y tus ventas
              mientras aprendes paso a paso cómo funciona realmente Amazon.
            </p>
            <p className="text-base md:text-lg text-brand-text/70 leading-relaxed italic" data-id="element-962">
              Ideal para personas que quieren empezar con una inversión más
              baja, menos complicaciones y una forma más práctica de generar
              ingresos online.
            </p>
          </div>

          {/* Texto de refuerzo - bullets */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto mb-10 text-left" data-id="element-963">
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-964">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-965" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-966">
                Menor inversión inicial
              </span>
            </div>
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-967">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-968" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-969">
                Más control sobre tus productos
              </span>
            </div>
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-970">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-971" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-972">
                Aprende desde cero paso a paso
              </span>
            </div>
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-973">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-974" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-975">
                Empieza desde casa incluso si eres principiante
              </span>
            </div>
          </div>

          {/* Frase final */}
          <p className="text-xl md:text-2xl font-serif text-brand-green font-semibold leading-relaxed" data-id="element-976">
            Amazon FBM puede ser el primer paso que necesitabas para comenzar tu
            negocio online.
          </p>
        </FadeIn>
      </div>
    </section>;
}